import type { LucideIcon } from "lucide-react";
import { Hash, Mail, MessageSquare, MessagesSquare, Phone } from "lucide-react";
import { cn } from "@/lib/utils";
import { commsChannelForProvider, type CommsChannel } from "./commsChannel";

const CHANNEL_META: Record<CommsChannel, { label: string; Icon: LucideIcon }> =
  {
    email: { label: "Email", Icon: Mail },
    sms: { label: "SMS", Icon: Phone },
    chat: { label: "Chat", Icon: MessagesSquare },
    slack: { label: "Slack", Icon: Hash },
    other: { label: "Message", Icon: MessageSquare },
  };

/**
 * A compact icon + label marking the rail a referenced message travelled on, so
 * a mixed message list stays scannable without a per-rail card layout.
 * @param provider - The comms message `provider` value
 */
export const CommsProviderBadge = ({
  provider,
  className,
}: {
  provider: string;
  className?: string;
}) => {
  const { label, Icon } = CHANNEL_META[commsChannelForProvider(provider)];
  return (
    <span
      className={cn(
        "inline-flex shrink-0 items-center gap-1 text-[11px] font-medium text-muted-foreground",
        className,
      )}
    >
      <Icon className="h-3 w-3" aria-hidden />
      {label}
    </span>
  );
};
